<template>
	<div v-bind:class="`chip-status status-${cleanState} ${size}`" v-bind:style="styleRoom">
		<span v-if="extraState" :class="`extra-state sprite-states ${extraState}`"></span>
		<button v-if="isAdded && !room.isSelected"
				class="is-added"
				v-on:click="removeOfList(roomId)">
			<i class="material-icons">cancel</i>
		</button>
		<input type="checkbox" hidden :disabled="isAdded" v-on:change="onChange(room)" v-model="room.isSelected" name="rooms" :id="labelFor">
		<label :for="labelFor" :class="{ 'disabled': isAdded, 'label-with-circle': showCircle }" :style="`background-color: ${backgroundColor}`">
			<div v-if="showCircle" class="check-circle-container">
				<span class="check-circle" :class="{ 'close': isAdded }">
					<v-btn
						type="button"
						class="remove-icon"
						v-if="isAdded"
						v-on:click.stop="removeOfList(roomId)">
						<v-icon>close</v-icon>
					</v-btn>
					<v-icon v-if="!isAdded && room.isSelected">check</v-icon>
				</span>
			</div>
			<div v-if="name">
				<p>{{ name }}</p>
			</div>
			<div v-else>
				<p>{{ number }}</p>
				<span>{{ code }}</span>
				<span
					v-if="showCircle && isAdded"
					class="name-state">
					{{ stateCode }}
				</span>
			</div>
			<div v-if="statusIcon" class="chip-icon" :class="{ 'top-status': nameState }">
				<span v-bind:class="`sprite-states ${statusIcon}`"></span>
			</div>
			<div v-else-if="statusIconImg" class="chip-icon" :class="{ 'top-status': nameState }">
				<img :src="statusIconImg" alt="">
			</div>
		</label>
		<div class="name-label" v-if="nameState">
			{{ nameState }}
		</div>
	</div>
</template>

<script>
function onChange(value) {
	const newValue = value;
	newValue.isAdded = newValue.isSelected;
	this.$emit('on-room-selected', newValue);
}

function created() {
	if (this.nameState) {
		this.styleRoom = 'display: inline-block';
	}
}

function removeOfList(id) {
	this.$emit('on-room-removed', id);
}

export default {
	created,
	data() {
		return {
			styleRoom: '',
		};
	},
	methods: {
		onChange,
		removeOfList,
	},
	name: 'room-status',
	props: {
		backgroundColor: {
			type: String,
		},
		cleanState: {
			type: Number,
			default: 1,
		},
		number: {
			type: [Number, String],
		},
		code: {
			type: String,
		},
		size: {
			type: String,
			default: 'large',
		},
		name: {
			type: String,
			default: null,
		},
		statusIcon: {
			type: String,
			default: null,
		},
		statusIconImg: {
			type: String,
			default: null,
		},
		isAdded: {
			type: Boolean,
			default: false,
		},
		extraState: {
			type: String,
			default: null,
		},
		labelFor: {
			type: [Number, String],
		},
		room: {
			type: Object,
		},
		roomId: {
			type: Number,
		},
		showCircle: {
			type: Boolean,
			default: false,
		},
		stateCode: {
			type: String,
			default: '',
		},
		nameState: {
			type: String,
			default: '',
		},
	},
};
</script>

<style lang="scss" scoped>
.chip-status {
	display: inline-flex;
	position: relative;
	text-align: center;

	label {
		position: relative;

		p {
			margin: 0;
		}

		span {
			display: block;
			font-size: map-get($sizes, thirdteen);
			font-weight: map-get($weights, w-six);
		}
	}

	&.medium,
	&.large {
		margin: 0 9.5px 15px 0px;
	}
}

.chip-icon {
    align-items: center;
	background-color: #d8d8d8;
	border-bottom-right-radius: 60px;
	border-top-right-radius: 60px;
    bottom: 0;
	display: flex;
	height: 111%;
	justify-content: center;
	margin: auto;
    position: absolute;
    right: -3px;
    top: 0;
	width: 15px;
}

.extra-state {
    left: 0;
    margin: 0 auto;
	position: absolute;
    right: 0;
    top: -5px;
    z-index: 1;
}

.medium {
	.chip-icon {
		border-bottom-right-radius: 118.8px;
		border-top-right-radius: 118.8px;
		width: 19.7px;
	}
}

.large {
	.chip-icon {
		border-bottom-right-radius: 165px;
		border-top-right-radius: 165px;
		width: 25px;
	}

	.extra-state {
		left: auto;
		margin: 0;
		right: -3px;
		top: -5px;
	}
}

.small {
	.chip-icon {
		height: 113%;
		
		img {
			height: 16px;
		}
	}
}

div[class*="status-"] {
	&.large {
		.sprite-states {
			&.booking {
				background-position: 0px 0px;
				height: 20px;
				width: 19px;
			}

			&.cleandeep {
				background-position: -19px 0px;
				height: 14.6px;
			}

			&.dirty {
				background-position: -79px 0px;
			}

			&.gym {
				background-position: -5px -31px;
				height: 11px;
				width: 16px;
			}

			&.locked {
				background-position: -110px 0px;
				height: 14.7px;
				width: 12.5px;
			}

			&.outofservice {
				background-position: -125px 0px;
				height: 14px;
				width: 15.1px;
			}

			&.turnover {
				background-position: -162px 0px;
				height: 15.4px;
				width: 14px;
			}

			&.maintenance {
				background-position: -192px 0px;
				height: 16px;
				width: 16px;
			}
		}
	}

	&.small {
		.sprite-states {
			&.booking {
				background-position: -5px -5px;
				height: 12px;
				width: 11px;
			}

			&.cleandeep {
				background-position: -19px 0px;
				height: 12.6px;
				width: 12.6px;
			}

			&.dirty {
				background-position: -61px 0px;
				height: 17.9px;
				width: 7.7px;
			}

			&.gym {
				background-position: -5px -31px;
				height: 11px;
				width: 16px;
			}

			&.locked {
				background-position: -95px 0px;
				height: 12.7px;
				width: 10.5px;
			}

			&.outofservice {
				background-position: -99px 0px;
				height: 11px;
				width: 10.1px;
			}

			&.turnover {
				background-position: -130px 0px;
				height: 12.4px;
				width: 14px;
			}

			&.maintenance {
				background-position: -144px 0px;
				height: 12px;
				width: 13px;
			}

			&.indeterminate {
				background-image: url('/static/img/sprites/spritesheet-icons.png');
				background-position: -1px 0px;
				background-size: 42px;
				height: 16.6px;
				width: 15.8px;
			}
		}
	}
}

.status-1 {

	&.large {
		label {
			@include room-status-large(map-get($colors, default-red));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, default-red));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, default-red));
		}
	}
}

.status-2 {
	&.large {
		label {
			@include room-status-large(map-get($colors, default-green));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, default-green));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, default-green));
		}
	}
}

.status-3 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-turnover));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-turnover));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-turnover));
		}
	}
}

.status-4 {
	&.large {
		label {
			@include room-status-large(map-get($colors, default-yellow));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, default-yellow));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, default-yellow));
		}
	}
}

.status-5 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-deepcleaning));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-deepcleaning));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-deepcleaning));
		}
	}
}

.status-6 {
	&.large {
		label {
			@include room-status-large(map-get($colors, default-red));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, default-red));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, default-red));
		}
	}
}

.status-7 {
	&.large {
		label {
			@include room-status-large(map-get($colors, default-green));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, default-green));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, default-green));
		}
	}
}

.status-8 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-outofserv));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-outofserv));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-outofserv));
		}
	}
}

.status-9 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-blocked));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-blocked));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-blocked));
		}
	}
}

.status-10 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-gym));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-gym));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-gym));
		}
	}
}

.status-11 {
	&.large {
		label {
			@include room-status-large(map-get($colors, e-halley));
		}
	}

	&.medium {
		label {
			@include room-status-medium(map-get($colors, e-halley));
		}
	}

	&.small {
		label {
			@include room-status(map-get($colors, e-halley));
		}
	}
}

.is-added {
	background-color: white;
	border-radius: 50%;
	height: 15px;
	margin: 0px;
	outline: none;
	position: absolute;
	right: -5px;
	top: -4px;
	width: 15px;
	z-index: 1;

	i {
		color: map-get($colors, default-dark);
		font-size: map-get($sizes, twenty);
		line-height: 15px;
		margin-left: -2px;
	}
}

.check-circle {
	border: 2px solid rgba(0, 0, 0, .11);
	border-radius: 100%;
	display: inline-flex;
	height: 20px;
	width: 20px;

	&-container {
		display: inline-flex;
		margin: 0 11px;
	}
}

label {
	cursor: pointer;

	&.disabled {
		cursor: default;
		pointer-events: none;
	}

	&.label-with-circle {
		justify-content: initial !important;
	}
}

input:checked + label {
	border: 2px solid map-get($colors, default-skyblue) !important;

	.chip-icon {
		height: 100%;
		right: 0;
	}

	.check-circle {
		background-color: white;
		border-color: map-get($colors, default-skyblue);
		display: inline-flex;

		i {
			color: map-get($colors, default-skyblue);
			font-size: map-get($sizes, sixteen);
		}

		&.close {
			border-color: black;

			i {
				color: black;
			}
		}
	}

	&.disabled {
		border: 0px !important;
	}
}

.remove-icon {
	background-color: transparent !important;
	box-shadow: none !important;
	height: auto;
	min-width: auto;
	pointer-events: all;

	.btn__content {
		padding: 0px;
	}
}

.name-state {
	border-top: 1px solid white;
	font-family: map-get($fonts, regular);
	font-size: map-get($sizes, twelve);
}

.name-label {
	color: map-get($colors, default-label);
	font-size: map-get($sizes, fourteen);
	margin-bottom: 15px;
	margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// RoomStatus.vue?68df1350